export interface ComicData {
  id: string;
  slug: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  latestChapter: string;
  updateTime: string;
  rating: number;
  views: number;
  chapters: ChapterData[];
}

export interface ChapterData {
  id: string;
  title: string;
  updateTime: string;
}

export interface CategoryData {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  image: string;
}

export const categories: CategoryData[] = [
  {
    slug: 'love',
    name: '恋爱',
    description: '甜蜜浪漫的爱情故事',
    icon: 'ri-heart-line',
    count: 128,
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%20soft%20pink%20watercolor%20style%20couple%20embracing%20under%20cherry%20blossoms%20warm%20gentle%20lighting%20dreamy%20atmosphere%20clean%20background%20artist%20illustration%20style&width=600&height=400&seq=category-love-01&orientation=landscape'
  },
  {
    slug: 'action',
    name: '动作',
    description: '热血激燃的战斗场面',
    icon: 'ri-fire-line',
    count: 96,
    image: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20illustration%20dynamic%20fight%20scene%20martial%20arts%20warrior%20red%20and%20black%20color%20scheme%20intense%20energy%20clean%20stylized%20art%20background%20with%20speed%20lines%20professional%20illustration&width=600&height=400&seq=category-action-02&orientation=landscape'
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    description: '宏大的幻想世界冒险',
    icon: 'ri-magic-line',
    count: 85,
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20illustration%20magical%20realm%20castle%20floating%20in%20sky%20purple%20and%20gold%20color%20palette%20mystical%20atmosphere%20ethereal%20lighting%20clean%20artistic%20illustration%20style%20soft%20gradient%20background&width=600&height=400&seq=category-fantasy-03&orientation=landscape'
  },
  {
    slug: 'suspense',
    name: '悬疑',
    description: '扣人心弦的推理故事',
    icon: 'ri-search-eye-line',
    count: 62,
    image: 'https://readdy.ai/api/search-image?query=Korean%20suspense%20thriller%20manhwa%20illustration%20dark%20alleyway%20mysterious%20shadow%20figure%20moody%20blue%20and%20gray%20tones%20atmospheric%20noir%20style%20clean%20illustration%20with%20dramatic%20lighting%20contrast&width=600&height=400&seq=category-suspense-04&orientation=landscape'
  },
  {
    slug: 'comedy',
    name: '搞笑',
    description: '轻松幽默的日常趣事',
    icon: 'ri-emotion-laugh-line',
    count: 74,
    image: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20illustration%20funny%20chibi%20characters%20bright%20yellow%20and%20orange%20colors%20playful%20cartoon%20style%20laughing%20expressions%20clean%20simple%20background%20warm%20cheerful%20atmosphere&width=600&height=400&seq=category-comedy-05&orientation=landscape'
  },
  {
    slug: 'drama',
    name: '剧情',
    description: '深刻动人的现实故事',
    icon: 'ri-emotion-line',
    count: 53,
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20illustration%20emotional%20character%20portrait%20tear%20falling%20down%20cheek%20warm%20brown%20and%20beige%20tones%20soft%20melancholic%20lighting%20clean%20artistic%20style%20gentle%20atmosphere%20professional%20illustration&width=600&height=400&seq=category-drama-06&orientation=landscape'
  },
];

export const featuredComics: ComicData[] = [
  {
    id: '1',
    slug: 'queen-of-tears',
    title: '眼泪女王',
    author: '金作家',
    category: '恋爱',
    tags: ['恋爱', '都市', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20elegant%20woman%20in%20white%20dress%20tears%20falling%20soft%20pink%20background%20with%20flower%20petals%20watercolor%20style%20delicate%20artwork%20dreamy%20atmosphere%20professional%20illustration%20clean%20composition&width=400&height=560&seq=comic-queen-tears&orientation=portrait',
    description: '她曾是高高在上的财阀千金，却在一场意外后失去了所有记忆。当他以陌生人的身份再次出现，她的心为何跳得如此之快？一段跨越阶层的爱情故事，眼泪背后藏着无法言说的秘密。',
    status: '连载中',
    latestChapter: '第48话',
    updateTime: '2026-07-03',
    rating: 9.6,
    views: 1250000,
    chapters: [],
  },
  {
    id: '2',
    slug: 'blade-of-destiny',
    title: '命运之刃',
    author: '李画师',
    category: '动作',
    tags: ['动作', '武侠', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20warrior%20holding%20glowing%20sword%20on%20cliff%20edge%20red%20moon%20background%20dramatic%20lighting%20epic%20fantasy%20style%20clean%20illustration%20dynamic%20composition%20professional%20artwork&width=400&height=560&seq=comic-blade-destiny&orientation=portrait',
    description: '在乱世中，一把神秘的剑选择了他。从此，一个普通少年踏上了不平凡的征途。敌人、盟友、背叛、牺牲——命运之刃将指引他走向何方？',
    status: '连载中',
    latestChapter: '第62话',
    updateTime: '2026-07-02',
    rating: 9.4,
    views: 980000,
    chapters: [],
  },
  {
    id: '3',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '崔大师',
    category: '奇幻',
    tags: ['奇幻', '校园', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%20young%20student%20casting%20spell%20at%20magical%20academy%20glowing%20blue%20magic%20circle%20mystical%20school%20background%20enchanting%20atmosphere%20clean%20illustration%20professional%20artwork&width=400&height=560&seq=comic-magic-academy&orientation=portrait',
    description: '在一个所有人都能使用魔法的世界里，他却是个魔法的绝缘体。直到那天，一本古老的魔法书选择了他——原来他不是没有魔法，而是被封印了这个世界最强大的力量。',
    status: '连载中',
    latestChapter: '第55话',
    updateTime: '2026-07-01',
    rating: 9.5,
    views: 1100000,
    chapters: [],
  },
  {
    id: '4',
    slug: 'night-detective',
    title: '暗夜侦探',
    author: '韩推理',
    category: '悬疑',
    tags: ['悬疑', '推理', '犯罪'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20manhwa%20cover%20art%20detective%20in%20trench%20coat%20standing%20under%20streetlamp%20at%20night%20dark%20blue%20rainy%20background%20noir%20atmosphere%20clean%20illustration%20professional%20artwork%20dramatic%20shadows&width=400&height=560&seq=comic-night-detective&orientation=portrait',
    description: '首尔的夜晚隐藏着无数秘密。他是一个退休警察，却在每一个深夜被离奇的案件拉回现场。当一桩连环失踪案与他多年前的旧案产生关联，真相开始浮出水面。',
    status: '连载中',
    latestChapter: '第41话',
    updateTime: '2026-06-30',
    rating: 9.3,
    views: 760000,
    chapters: [],
  },
];

export const latestComics: ComicData[] = [
  {
    id: '5',
    slug: 'puppy-love',
    title: '萌宠恋人',
    author: '朴暖心',
    category: '恋爱',
    tags: ['恋爱', '喜剧', '宠物'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20comedy%20manhwa%20cover%20art%20cute%20couple%20with%20golden%20retriever%20puppy%20bright%20sunny%20park%20background%20warm%20yellow%20and%20green%20tones%20gentle%20atmosphere%20clean%20illustration%20professional%20artwork&width=400&height=560&seq=comic-puppy-love&orientation=portrait',
    description: '她是一个宠物美容师，他是一位冷漠的CEO。一只走失的小狗让他们的人生轨迹意外交汇——谁能想到，这只调皮的毛孩子竟然成了最棒的媒人？',
    status: '连载中',
    latestChapter: '第32话',
    updateTime: '2026-07-03',
    rating: 9.2,
    views: 680000,
    chapters: [],
  },
  {
    id: '6',
    slug: 'dragon-warrior',
    title: '龙战士',
    author: '郑热血',
    category: '动作',
    tags: ['动作', '奇幻', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20cover%20art%20dragon%20warrior%20with%20flaming%20fists%20battling%20giant%20dragon%20epic%20volcano%20background%20orange%20and%20red%20fiery%20color%20palette%20clean%20illustration%20dynamic%20professional%20artwork&width=400&height=560&seq=comic-dragon-warrior&orientation=portrait',
    description: '龙族与人类的战争持续了千年。他是最后一个龙血战士，肩负着终结战争或毁灭世界的使命。当他发现自己体内沉睡着远古龙王的力量时，一切都将改变。',
    status: '连载中',
    latestChapter: '第39话',
    updateTime: '2026-07-02',
    rating: 9.1,
    views: 540000,
    chapters: [],
  },
  {
    id: '7',
    slug: 'starry-sky',
    title: '星空下的约定',
    author: '尹治愈',
    category: '恋爱',
    tags: ['恋爱', '青春', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20young%20couple%20gazing%20at%20starry%20night%20sky%20on%20hilltop%20deep%20blue%20and%20silver%20color%20scheme%20romantic%20atmosphere%20clean%20illustration%20professional%20artwork%20soft%20glowing%20stars&width=400&height=560&seq=comic-starry-sky&orientation=portrait',
    description: '高中毕业前的最后一个夏天，她和他在天文台相遇。他们约定每年看一次流星雨，但这个约定能坚持多久？时间流逝，唯有星空见证他们的青春。',
    status: '已完结',
    latestChapter: '第60话（完结）',
    updateTime: '2026-06-28',
    rating: 9.7,
    views: 890000,
    chapters: [],
  },
  {
    id: '8',
    slug: 'shadow-king',
    title: '暗影之王',
    author: '孙奇幻',
    category: '奇幻',
    tags: ['奇幻', '黑暗', '转生'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20art%20shadow%20king%20on%20throne%20dark%20castle%20interior%20purple%20and%20black%20color%20scheme%20mysterious%20atmosphere%20clean%20illustration%20professional%20artwork%20gothic%20style&width=400&height=560&seq=comic-shadow-king&orientation=portrait',
    description: '被最信任的伙伴背叛而死，醒来却发现自己回到了二十年前。带着前世所有的记忆和痛苦，他将一步步走向权力的巅峰，成为令所有敌人颤抖的暗影之王。',
    status: '连载中',
    latestChapter: '第71话',
    updateTime: '2026-07-03',
    rating: 9.8,
    views: 1560000,
    chapters: [],
  },
];

export const rankingComics: ComicData[] = [
  {
    id: '8',
    slug: 'shadow-king',
    title: '暗影之王',
    author: '孙奇幻',
    category: '奇幻',
    tags: ['奇幻', '黑暗', '转生'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20art%20shadow%20king%20on%20throne%20dark%20castle%20interior%20purple%20and%20black%20color%20scheme%20mysterious%20atmosphere%20clean%20illustration%20professional%20artwork%20gothic%20style&width=400&height=560&seq=comic-shadow-king&orientation=portrait',
    description: '被最信任的伙伴背叛而死，醒来却发现自己回到了二十年前。带着前世所有的记忆和痛苦，他将一步步走向权力的巅峰。',
    status: '连载中',
    latestChapter: '第71话',
    updateTime: '2026-07-03',
    rating: 9.8,
    views: 1560000,
    chapters: [],
  },
  {
    id: '1',
    slug: 'queen-of-tears',
    title: '眼泪女王',
    author: '金作家',
    category: '恋爱',
    tags: ['恋爱', '都市', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20elegant%20woman%20in%20white%20dress%20tears%20falling%20soft%20pink%20background%20with%20flower%20petals%20watercolor%20style%20delicate%20artwork%20dreamy%20atmosphere%20professional%20illustration%20clean%20composition&width=400&height=560&seq=comic-queen-tears&orientation=portrait',
    description: '她曾是高高在上的财阀千金，却在一场意外后失去了所有记忆。',
    status: '连载中',
    latestChapter: '第48话',
    updateTime: '2026-07-03',
    rating: 9.6,
    views: 1250000,
    chapters: [],
  },
  {
    id: '7',
    slug: 'starry-sky',
    title: '星空下的约定',
    author: '尹治愈',
    category: '恋爱',
    tags: ['恋爱', '青春', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20young%20couple%20gazing%20at%20starry%20night%20sky%20on%20hilltop%20deep%20blue%20and%20silver%20color%20scheme%20romantic%20atmosphere%20clean%20illustration%20professional%20artwork%20soft%20glowing%20stars&width=400&height=560&seq=comic-starry-sky&orientation=portrait',
    description: '高中毕业前的最后一个夏天，她和他在天文台相遇。',
    status: '已完结',
    latestChapter: '第60话（完结）',
    updateTime: '2026-06-28',
    rating: 9.7,
    views: 890000,
    chapters: [],
  },
  {
    id: '3',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '崔大师',
    category: '奇幻',
    tags: ['奇幻', '校园', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%20young%20student%20casting%20spell%20at%20magical%20academy%20glowing%20blue%20magic%20circle%20mystical%20school%20background%20enchanting%20atmosphere%20clean%20illustration%20professional%20artwork&width=400&height=560&seq=comic-magic-academy&orientation=portrait',
    description: '在一个所有人都能使用魔法的世界里，他却是个魔法的绝缘体。',
    status: '连载中',
    latestChapter: '第55话',
    updateTime: '2026-07-01',
    rating: 9.5,
    views: 1100000,
    chapters: [],
  },
  {
    id: '2',
    slug: 'blade-of-destiny',
    title: '命运之刃',
    author: '李画师',
    category: '动作',
    tags: ['动作', '武侠', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20warrior%20holding%20glowing%20sword%20on%20cliff%20edge%20red%20moon%20background%20dramatic%20lighting%20epic%20fantasy%20style%20clean%20illustration%20dynamic%20composition%20professional%20artwork&width=400&height=560&seq=comic-blade-destiny&orientation=portrait',
    description: '在乱世中，一把神秘的剑选择了他。',
    status: '连载中',
    latestChapter: '第62话',
    updateTime: '2026-07-02',
    rating: 9.4,
    views: 980000,
    chapters: [],
  },
];

export const allComics: ComicData[] = [...featuredComics, ...latestComics];